// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DesktopIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DesktopIcon" ref={forwardedRef} {...props}>
      <path d="M3 3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h6.25v2H6v1.5h8V16h-3.25v-2H17a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h13v8h-13z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DesktopIcon = /* @__PURE__ */ Object.assign(DesktopIconComponent, {
  displayName: 'DesktopIcon',
});
